import React from 'react';
import clsx from 'clsx';
import { LineWave } from 'react-loader-spinner';
import styles from './styles.module.scss';

const ApiLoader = ({ className, overlayMode }) => {
  return (
    <div
      className={clsx(
        'loader-container',
        className,
        overlayMode && styles.overlay_mode
      )}
    >
      {/* <Loader type='' color='rgb(177, 14, 132)' height={80} width={80} /> */}
      <LineWave
        height={120}
        width={120}
        color='rgb(177, 14, 132)'
        ariaLabel='line-wave'
        wrapperStyle={{}}
        wrapperClass=''
        visible={true}
      />
    </div>
  );
};

ApiLoader.defaultProps = {
  className: '',
  overlayMode: false,
};

export default ApiLoader;
